"use client";

import type { FC } from "react";
import { cn } from "@/lib/cn";
import { HoverTooltip } from "./hover-tooltip";

type DotListProps = {
  items?: string[];
  truncate?: boolean;
  className?: string;
  itemClassName?: string;
  separatorClassName?: string;
};

export const DotList: FC<DotListProps> = ({
  items,
  truncate = true,
  className,
  itemClassName,
  separatorClassName,
}) => {
  const cleaned = (items ?? []).filter((item) => Boolean(item?.trim()));
  if (cleaned.length === 0) return null;

  return (
    <HoverTooltip label={cleaned.join(" · ")} className={cn("items-center gap-8", truncate && "overflow-hidden", className)}>
      {cleaned.map((item, index) => {
        const isLast = truncate && index === cleaned.length - 1;
        return (
          <span key={`${item}-${index}`} className={cn("flex items-center gap-8", isLast ? "min-w-0" : "shrink-0")}>
            {index > 0 && (
              <span aria-hidden className={cn("shrink-0 text-current opacity-50", separatorClassName)}>
                ·
              </span>
            )}
            <span className={cn("whitespace-nowrap", isLast && "min-w-0 truncate", itemClassName)}>{item}</span>
          </span>
        );
      })}
    </HoverTooltip>
  );
};
